import * as tslib_1 from "tslib";
import { AfterViewInit, ChangeDetectorRef, EventEmitter, ViewContainerRef } from '@angular/core';
import { ESRI } from '../../esri-loader-util';
import { BooleanConverter } from '../../inputConverter';
import { BaseComponent } from '../base.component';
var Extent;
var BookmarkComponent = /** @class */ (function (_super) {
    tslib_1.__extends(BookmarkComponent, _super);
    function BookmarkComponent(authService, UserSettingsService, changeDetectorRef, _vcr) {
        var _this = _super.call(this, _vcr, true) || this;
        _this.authService = authService;
        _this.UserSettingsService = UserSettingsService;
        _this.changeDetectorRef = changeDetectorRef;
        _this._active = false;
        _this.activeChange = new EventEmitter();
        _this.inputText = null;
        _this.bookmarks = [];
        return _this;
    }
    Object.defineProperty(BookmarkComponent.prototype, "active", {
        get: function () { return this._active; },
        set: function (value) {
            this._active = BooleanConverter(value);
            value ? this.activate() : this.deactivate();
            this.activeChange.emit(value);
        },
        enumerable: true,
        configurable: true
    });
    BookmarkComponent.prototype.ngAfterViewInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!this.mapView) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.setupMapViewRef(this.mapView)];
                    case 1:
                        _a.mapView = _b.sent();
                        this.isReady();
                        _b.label = 2;
                    case 2: return [4 /*yield*/, ESRI.Extent];
                    case 3:
                        Extent = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    BookmarkComponent.prototype.activate = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!this.userSubscriber) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.authService.GetCurrentUser().subscribe(function (user) {
                                if (user && user.id) {
                                    _this.userEmail = user.emailAddress;
                                    _this.loadUserSettings();
                                }
                            })];
                    case 1:
                        _a.userSubscriber = _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    BookmarkComponent.prototype.deactivate = function () {
        this.userSubscriber.unsubscribe();
        this.userSubscriber = undefined;
    };
    BookmarkComponent.prototype.loadUserSettings = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.setupMapViewRef(this.mapView)];
                    case 1:
                        _a.mapRef = _b.sent();
                        this.UserSettingsService.GetSettingValue('bookmarks', this.appName, this.userEmail).subscribe(function (results) {
                            _this.bookmarks = results || [];
                            _this.changeDetectorRef.detectChanges();
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    BookmarkComponent.prototype.saveBookmark = function () {
        this.bookmarks.push({ name: this.inputText, extent: this.mapView.extent.toJSON() });
        this.inputText = null;
        this.saveSettings();
    };
    BookmarkComponent.prototype.saveSettings = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.UserSettingsService.SetSettingValue('bookmarks', this.bookmarks, this.userEmail, this.appName)];
                    case 1:
                        _a.sent();
                        this.changeDetectorRef.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    BookmarkComponent.prototype.deleteExtent = function (index) {
        this.bookmarks.splice(index, 1);
        this.saveSettings();
    };
    BookmarkComponent.prototype.goToExtent = function (index) {
        this.mapView.goTo(Extent.fromJSON(this.bookmarks[index].extent), { animate: true });
    };
    return BookmarkComponent;
}(BaseComponent));
export { BookmarkComponent };
